<template>
 <div class="categoryListItem" >
     <img style="width: 100%; height: 100px;  border-top-left-radius: 10px; border-top-right-radius: 10px;" @click="onList(categoryItem.id, categoryItem.parentId)"  :src="categoryItem.icon">
     <div class="goods-info" @click="onList(categoryItem.id, categoryItem.parentId)" style="text-align:center; position: relative; bottom: 10px">
         <p v-if="langType=='cn'" style="font-weight: 800; font-size: 14px; letter-spacing:2px; ">{{categoryItem.nameCn}}</p>
         <p v-if="langType=='en'" style="font-weight: 800; font-size: 14px; letter-spacing:2px; ">{{categoryItem.nameEn}}</p>
     </div>
 </div>
</template>

<script>
import { langPackage } from "@/config/lang/goodsInfoLang";
import { selectLang } from "@/config/setLanguage"

export default {
        name: "categoryListItem",
        data(){
          return{
            langType:"cn"
          }
        },
        props:{
            categoryItem: {
                type: Object,
                default(){
                    return {}
                }
            }
        },
        methods:{
            onList(id, pid){ //点击二级导航跳转列表页
                this.$router.push({
                    path:'/goods/goodsList',
                    query:{
                        categoryId: id,
                        categoryPid: pid,
                        oneActive: this.activeKey
                    }
                })
            }
        },
            created() {
              //获取语言包
              selectLang(langPackage).then(langtxt => {
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
                this.langType = langtxt.type;
              });
            },
    }
</script>

<style scoped>

    .categoryListItem{
        width: 90%;
        padding-bottom: 60px;
        position: relative;
        background: #ffffff;
        margin: 4px;
        border-radius: 10px;
        height: 75px;
    }



    .goods-info p{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 3px;
    }

</style>
